import type { Stack, Category } from '@/payload-types'

export function filterStacksByCategory(
  stacks: Stack[],
  selectedCategory: Pick<Category, 'id' | 'name' | 'slug'> | null,
) {
  if (selectedCategory === null) {
    return stacks
  }

  return stacks.filter((stack) => stack.type === selectedCategory.slug)
}
